<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3>
                        <feather-icon icon-pack="feather-icon" icon="PlusIcon"></feather-icon>
                        Create New Interface
                    </h3>
                </div>
                <div>
                    <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Finish">
                        <tab-content title="Step 1" class="mb-5" icon="feather icon-settings" :before-change="validateStep1">

                            <!-- tab 1 content -->
                            <form @submit.prevent="validateStep1" data-vv-scope="step-1">
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5">
                                        <vs-input data-vv-name="title" label="Title" v-model="title" class="w-full" name="title" v-validate="'required'"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.title')">{{ errors.first('step-1.title') }}</span>
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <vs-textarea data-vv-name="description" class="w-full" label="Description" v-validate="'max:250'" counter="250" :counter-danger.sync="counterDanger" v-model="description"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-1.description')">{{ errors.first('step-1.description') }}</span>
                                    </div>
                                </div>
                            </form>
                        </tab-content>

                        <!-- tab 2 content -->
                        <tab-content title="Step 2" class="mb-5" icon="feather icon-radio" :before-change="validateStep2">
                            <form @submit.prevent="validateStep2" data-vv-scope="step-2">
                                <vs-row vs-w="12">
                                    <vs-col vs-w="3">
                                        <label>HTTP Method</label>
                                        <vs-select class="selectExample w-full" v-model="http_method">
                                            <vs-select-item value="GET" text="GET"/>
                                            <vs-select-item value="POST" text="POST"/>
                                            <vs-select-item value="DELETE" text="DELETE"/>
                                            <vs-select-item value="COPY" text="COPY"/>
                                            <vs-select-item value="PATCH" text="PATCH"/>
                                            <vs-select-item value="PUT" text="PUT"/>
                                        </vs-select>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.http_method')">{{ errors.first('step-2.http_method') }}</span>
                                    </vs-col>
                                    <vs-col vs-w="7">
                                        <vs-input label="URL" v-model="url" class="w-full" name="url" v-validate="'required'"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.url')">{{ errors.first('step-2.url') }}</span>
                                    </vs-col>
                                    <vs-col vs-w="2">
                                        <vs-input v-validate="'numeric'" placeholder="80 (Default)" label="Port" v-model="port" class="w-full" name="port"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-2.port')">{{ errors.first('step-2.port') }}</span>
                                    </vs-col>
                                </vs-row>
                            </form>
                        </tab-content>

                        <!-- tab 3 content -->
                        <tab-content title="Step 3" class="mb-5" icon="feather icon-grid" :before-change="validateStep3">
                            <form @submit.prevent="validateStep3" data-vv-scope="step-2">
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5">
                                        <vs-textarea rows="10" data-vv-name="headers_data" class="w-full" label="headers_data" v-model="headers_data"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-3.headers_data')">{{ errors.first('step-3.headers_data') }}</span>
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <vs-textarea rows="30" data-vv-name="body" class="w-full" label="Body" v-model="body"/>
                                        <span class="text-danger text-sm" v-show="errors.has('step-3.body')">{{ errors.first('step-3.body') }}</span>
                                    </div>
                                </div>
                            </form>
                        </tab-content>
                    </form-wizard>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>


<script>

    import Configs from '../../config.js';
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    export default {
        data() {
            return {
                counterDanger: false,
                title: null,
                description: null,
                url: null,
                port: null,
                headers_data: null,
                body: null,
                http_method: "GET"
            }
        },
        components: {
            FormWizard,
            TabContent
        },
        created() {
            this.setBreadCrumbsItems();
        },
        methods: {
            submit() {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/interfaces/create',
                    data: this.$data,
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.$vs.notify({title: 'Great', text: 'You successfully added new interface', color: 'success', iconPack: 'feather', icon: 'icon-check'});
                    this.$router.push({name: 'interfaces-show'});
                }).catch((err) => {
                    this.$setLaravelValidationErrorsFromResponse(err.response.data);
                    this.loader = false;
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Interfaces',
                        url: '/interfaces/show'
                    },
                    {
                        title: 'Add New Interface',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            },
            validateStep1() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll('step-1').then(result => {
                        if (result) {
                            resolve(true)
                        } else {
                            reject("correct all values");
                        }
                    })
                })
            },
            validateStep2() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll("step-2").then(result => {
                        if (result) {
                            resolve(true)
                        } else {
                            reject("correct all values");
                        }
                    })
                })
            },
            validateStep3() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll("step-3").then(result => {
                        if (result) {
                            this.submit();
                            resolve(true)
                        } else {
                            reject("correct all values");
                        }
                    })
                })
            }
        }
    }
</script>

<style>
    .pagination-bar {
        display: none;
    }

    .options {
        margin: 1px !important;
        display: inline-flex !important;
    }
</style>